import * as actions from '../actions/restricted-functions-collection';
import * as models from '../../domain/models';

export interface State {
  isLoading: boolean;
  isLoaded: boolean;
  items: Array<models.RestrictedFunction>;
  userRestrictionsLoading: boolean;
  userRestrictionsLoaded: boolean;
  userRestrictions: Array<models.UserRestrictedFunction>;
  isUpdating: boolean;
}

const initialState: State = {
  isLoading: false,
  isLoaded: false,
  items: [],
  userRestrictionsLoading: false,
  userRestrictionsLoaded: false,
  userRestrictions: [],
  isUpdating: false,
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.RESET: {
      return { ...initialState };
    }

    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }

    case actions.LOAD_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        items: action.payload.items,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      };
    }

    case actions.LOAD_USER_RESTRICTIONS: {
      return {
        ...state,
        userRestrictionsLoading: true,
        userRestrictionsLoaded: false,
      };
    }

    case actions.LOAD_USER_RESTRICTIONS_SUCCESS: {
      return {
        ...state,
        userRestrictionsLoading: false,
        userRestrictionsLoaded: true,
        userRestrictions: action.payload.items,
      };
    }

    case actions.LOAD_USER_RESTRICTIONS_FAIL: {
      return {
        ...state,
        userRestrictionsLoading: false,
        userRestrictionsLoaded: false,
      };
    }

    case actions.LOAD_GROUP_RESTRICTIONS: {
      return {
        ...state,
        userRestrictionsLoading: true,
        userRestrictionsLoaded: false,
      };
    }

    case actions.LOAD_GROUP_RESTRICTIONS_SUCCESS: {
      return {
        ...state,
        userRestrictionsLoading: false,
        userRestrictionsLoaded: true,
        userRestrictions: action.payload.items,
      };
    }

    case actions.LOAD_GROUP_RESTRICTIONS_FAIL: {
      return {
        ...state,
        userRestrictionsLoading: false,
        userRestrictionsLoaded: false,
      };
    }

    case actions.UPDATE_RESTRICTIONS: {
      return {
        ...state,
        isUpdating: true,
      };
    }

    case actions.UPDATE_RESTRICTIONS_SUCCESS: {
      return {
        ...state,
        isUpdating: false,
      };
    }

    case actions.UPDATE_RESTRICTIONS_FAIL: {
      return {
        ...state,
        isUpdating: false,
      };
    }

    default:
      return state;
  }
}

export const getIsLoading = (state: State) => state.isLoading;
export const getIsLoaded = (state: State) => state.isLoaded;
export const getItems = (state: State) => state.items;
export const getUserRestrictionsLoading = (state: State) => state.userRestrictionsLoading;
export const getUserRestrictionsLoaded = (state: State) => state.userRestrictionsLoaded;
export const getUserRestrictions = (state: State) => state.userRestrictions;
export const getIsUpdating = (state: State) => state.isUpdating;
